import { render, staticRenderFns } from "./ForcePasswordReset.vue?vue&type=template&id=765bc104&scoped=true&"
import script from "./ForcePasswordReset.vue?vue&type=script&lang=js&"
export * from "./ForcePasswordReset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "765bc104",
  null
  
)

export default component.exports